export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEJRVRlbi1CNS1IYQihXQGBAgIBgQYCAYEKAgGBDgIBgRICAYEWAgGBGgIBgR5hBKFLAOpODgDrLwEA6zGBBgDqT2EBxuQB7hE=", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/ETen-B5-V.bcmap
// module id = 626
// module chunks = 502